export const BASE_URL = "https://apiuvenu.uvenu.com";
//export const BASE_URL = "https://dev-apiuvenu.uvenu.com";
export const PUBLIC_BASE_URL = "https://public-api.uvenu.com";
//export const PUBLIC_BASE_URL = "https://dev-public-api.uvenu.com";
export const URLS = {
  SERVER_CONFIG_URL: `${PUBLIC_BASE_URL}/config`,
  MONITOR_ONLINE_USERS: (eventId, sourceName) =>
    `${BASE_URL}/onlinePresence/monitorOnlineUsers?eventId=${eventId}&sourceName=${encodeURIComponent(
      sourceName
    )}`,
  GET_ONLINE_USERS: (eventId, sourceName, lastEventUserId, numUsers = "9") => {
    let url = `${BASE_URL}/onlinePresence/getOnlineUsers?eventId=${eventId}&sourceName=${encodeURIComponent(
      sourceName
    )}`;
    if (lastEventUserId) {
      url += `&lastEventUserId=${encodeURIComponent(lastEventUserId)}`;
    }
    if (numUsers) {
      url += `&numUsers=${encodeURIComponent(numUsers)}`;
    }
    return url;
  },
  ADMIN_LOGIN: `${BASE_URL}/admin/login`,
  GET_ALL_EVENTS: `${BASE_URL}/admin/getAllEvents`,
  CREATE_EVENT: `${BASE_URL}/admin/createEvent`,
  EVENT_INFO: (eventId) =>
    `${PUBLIC_BASE_URL}/event/getEvent?eventId=${encodeURIComponent(eventId)}`,
  EVENT_SETTINGS: (eventId) =>
    `${PUBLIC_BASE_URL}/event/${encodeURIComponent(eventId)}/output-settings`,
  EVENT_USERS_COUNTS: (eventId) =>
    `${BASE_URL}/admin/eventUserCounts?eventId=${encodeURIComponent(eventId)}`,
  EVENT_SCREEN_LINK: (eventId) =>
    `${window.location.origin}/eventScreen#${eventId}`,
  EVENT_JOIN_PAGE_LIVE: (eventId, options, page) =>
    `${window.location.origin}/joinEventLive#eventId=${eventId}&loadwithoptions=${options}&page=${page}`,
  EVENT_SCREEN_COMMAND_SUSCRIBE_LINK: (eventId, token) =>
    `${BASE_URL}/eventsScreen/subscribe?eventId=${eventId}&token=${token}`,
  EVENT_SCREEN_COMMAND_PUBLISH_LINK: `${BASE_URL}/eventsScreen/publish`,
  DELETE_EVENT: `${BASE_URL}/admin/deleteEvent`,
  EDIT_EVENT: `${BASE_URL}/admin/updateEvent`,
  UPLOAD_ADVERTISEMENT_BANNER: `${BASE_URL}/advertisement/upload`,
  UPDATE_ADVERTISEMENT_BANNER: `${BASE_URL}/advertisement/update`,
  ONLINE_PRESENCE: (userId, userName, eventId, uniqueId, sourceName) =>
    `${BASE_URL}/onlinePresence/online?userId=${encodeURIComponent(
      userId
    )}&userName=${encodeURIComponent(userName)}&eventId=${encodeURIComponent(
      eventId
    )}&uniqueId=${encodeURIComponent(uniqueId)}&sourceName=${encodeURIComponent(
      sourceName
    )}`,
  GET_ADVERTS_FOR_EVENT: (eventId) =>
    `${PUBLIC_BASE_URL}/advertisement/getAdvertsForEvent?eventId=${eventId}`,
  GET_NEARBY_EVENT: (latitude, longitude) =>
    `${PUBLIC_BASE_URL}/event/getNearbyEvents?coordinates=${latitude},${longitude}`,
  GET_ALL_GAME_DATA: (event_id) =>
    `${BASE_URL}/game/getGamesForEvent?eventId=${event_id}`,
  CREATE_GAME: `${BASE_URL}/game/create`,
  PATCH_GAME: `${BASE_URL}/game/update`,
  CLONE_GAME: `${BASE_URL}/game/clone`,
  GET_ACTIVE_GAME: (event_id, user_id) =>
    `${PUBLIC_BASE_URL}/game/getActiveGameForEvent?eventId=${event_id}&userId=${user_id}`,
  DELETE_GAME: (game_id) => `${BASE_URL}/game/delete?gameId=${game_id}`,
  DELETE_GAME_ANSWERS: (game_id) =>
    `${BASE_URL}/game/deleteGameAnswers?gameId=${game_id}`,
  SUBMIT_GAME_ANSWER: `${PUBLIC_BASE_URL}/game/submitAnswer`,
  GAME_SCREEN_LINK: (eventId, gameId) =>
    `${window.location.origin}/gameScreen#event=${eventId}&game=${gameId}`,
  GET_GAME_STATS: (gameId) =>
    `${PUBLIC_BASE_URL}/game/getGameResults?gameId=${gameId}`,
  GET_GAME_SCREEN_SETTINGS: (gameId) =>
    `${BASE_URL}/game/getGameResultsScreenSettings?gameId=${gameId}`,
  SAVE_LIGHT_SHOW_SETTINGS: `${BASE_URL}/lightShow/saveSettings`,
  GET_LIGHT_SHOW_SETTINGS: (event_id) =>
    `${PUBLIC_BASE_URL}/lightShow/getLightShowsSettingsForEvent?eventId=${event_id}`,
  GET_STREAMING_LIGHT_SHOW: (event_id) =>
    `${PUBLIC_BASE_URL}/lightShow/getStreamingShow?eventId=${event_id}`,
  CREATE_LIGHT_SHOW: `${BASE_URL}/lightShow/create`,
  PATCH_LIGHT_SHOW: `${BASE_URL}/lightShow/update`,
  DELETE_LIGHT_SHOW: (showId) =>
    `${BASE_URL}/lightShow/delete?showId=${showId}`,
  DELETE_PLAYBACK_FILE: (id) =>
    `${BASE_URL}/lightShow/deletePlaybackFile?fileId=${id}`,
  UPDATE_PLAYBACK_FILE: `${BASE_URL}/lightShow/updatePlaybackFile`,
  GET_LIGHT_SHOWS: (event_id) =>
    `${BASE_URL}/lightShow/getLightShowsForEvent?eventId=${event_id}`,
  GET_PLAYBACK_FILES: (event_id) =>
    `${BASE_URL}/lightShow/getPlaybackFilesForEvent?eventId=${event_id}`,
  UPLOAD_MEDIA: () => `${PUBLIC_BASE_URL}/sharedMedia/upload`,
  UPLOAD_GENERATED_MEDIA: () => `${BASE_URL}/sharedMedia/uploadGenerated`,
  UPLOAD_VIDEO_POSTER: () => `${PUBLIC_BASE_URL}/sharedMedia/uploadVideoPoster`,
  SEND_SOCIAL_LIKE: () => `${PUBLIC_BASE_URL}/sharedMedia/like`,
  GET_UNREVIEWED_MEDIA: (
    eventId,
    page,
    pageSize,
    mimeType,
    sortDirection,
    userNameContains,
    onlyApprovedQuotes,
    hasOnlyQuote,
    isProductionUploads,
    aiGenerated
  ) => {
    let url = `${BASE_URL}/sharedMedia/unreviewed?eventId=${eventId}&page=${page}&pageSize=${pageSize}`;
    if (onlyApprovedQuotes) url += `&showOnQuotesFeed=${onlyApprovedQuotes}`;
    if (hasOnlyQuote !== undefined && hasOnlyQuote !== null)
      url += `&hasOnlyQuote=${hasOnlyQuote}`;
    if (mimeType) url += `&mimeType=${mimeType}`;
    if (sortDirection) url += `&sortDirection=${sortDirection}`;
    if (userNameContains)
      url += `&userNameContains=${encodeURIComponent(userNameContains)}`;
    if (isProductionUploads)
      url += `&isProductionUploads=${isProductionUploads}`;
    if (aiGenerated) url += `&aiGenerated=${aiGenerated}`;
    return url;
  },
  REVIEW_MEDIA: `${BASE_URL}/sharedMedia/review`,
  REVIEW_BULK_MEDIA: `${BASE_URL}/sharedMedia/reviewBulk`,
  PURGE_ALL_MEDIA: `${BASE_URL}/sharedMedia/purgeMany`,
  GET_SOCIAL_SCROLL: (
    eventId,
    page,
    pageSize,
    mimeType,
    showOnQuotesFeed,
    sortDirection,
    userNameContains,
    hasOnlyQuote,
    aiGenerated
  ) => {
    let url = `${PUBLIC_BASE_URL}/sharedMedia/scroll?eventId=${eventId}&page=${page}&pageSize=${pageSize}`;
    if (showOnQuotesFeed) url += `&showOnQuotesFeed=${showOnQuotesFeed}`;
    if (hasOnlyQuote) url += `&hasOnlyQuote=${hasOnlyQuote}`;
    if (mimeType) url += `&mimeType=${mimeType}`;
    if (sortDirection) url += `&sortDirection=${sortDirection}`;
    if (userNameContains)
      url += `&userNameContains=${encodeURIComponent(userNameContains)}`;
    if (aiGenerated) url += `&aiGenerated=${aiGenerated}`;
    return url;
  },
  SOCIAL_OP_SCREEN_LINK: (eventId) =>
    `${window.location.origin}/Social#${eventId}`,
  SUPER_SCREEN_LINK: `${window.location.origin}/SuperScreen`,
  SOCIAL_OP_CAROUSEL_SCREEN_LINK: (eventId) =>
    `${window.location.origin}/SocialCarousel#${eventId}`,
  SOCIAL_OP_SLIDESHOW_SCREEN_LINK: (eventId) =>
    `${window.location.origin}/SocialSlideshow#${eventId}`,
  SOCIAL_OUTPUT_LINK: (eventId) =>
    `${window.location.origin}/social-output/${eventId}`,
  CONTROLLABLE_OUTPUT_LINK: (eventId) =>
    `${window.location.origin}/controllable-output/${eventId}`,
  SOCIAL_OP_DYNAMIC_MASONARY_SCREEN_LINK: (eventId) =>
    `${window.location.origin}/SocialDynamicMasonry#${eventId}`,
  SOCIAL_OP_FIXED_MASONARY_SCREEN_LINK: (eventId) =>
    `${window.location.origin}/SocialFixedMasonry#${eventId}`,
  SOCIAL_MEDIA_LIKE: `${PUBLIC_BASE_URL}/sharedMedia/like`,
  SUBMIT_USERS_EMAILS: (eventId) =>
    `${PUBLIC_BASE_URL}/event/${eventId}/contacts`,
  SAVE_PROMPT: `${BASE_URL}/event/savePrompt`,
  GET_PROMPTS: (eventId) => `${BASE_URL}/event/${eventId}/prompts`,
  DELETE_PROMPT: (id) => `${BASE_URL}/event/deletePrompt?promptId=${id}`,
  GET_LAST_MESSAGE: (id) =>
    `${BASE_URL}/event/getLastSocketMessage?eventId=${id}`,
  DELETE_LAST_MESSAGE: (id) =>
    `${BASE_URL}/event/deleteLastMessage?roomId=${id}`,
  CREATE_SUPER_SCREEN_LAYOUT: `${BASE_URL}/superScreen/create`,
  GET_SUPER_SCREEN_LAYOUTS: (event_id) =>
    `${BASE_URL}/superScreen/getSuperScreenLayouts?eventId=${event_id}`,
  DELETE_SUPER_SCREEN_LAYOUT: (layoutId) =>
    `${BASE_URL}/superScreen/delete?layoutId=${layoutId}`,
  PATCH_SUPER_SCREEN_LAYOUT: `${BASE_URL}/superScreen/update`,
  SEND_QUOTE: `${PUBLIC_BASE_URL}/quotes/post`,
  REVIEW_QUOTE: `${BASE_URL}/quotes/review`,
  UPLOAD_AUDIO: `${BASE_URL}/lightShow/uploadAudio`,
  DELETE_EVENT_CONTACTS: (eventId) =>
    `${BASE_URL}/event/deleteContacts?eventId=${eventId}`,
  GET_SELECTED_CONTROLLABLE_ITEMS: (eventId) =>
    `${BASE_URL}/controllableMedia/selected?eventId=${eventId}`,
  SAVE_SELECTED_CONTROLLABLE_ITEMS: `${BASE_URL}/controllableMedia/selected`,
  DELETE_TAB: (id) => `${BASE_URL}/controllableMedia/selected?id=${id}`,
  SAVE_CONTROLLABLE_OUTPUT: `${BASE_URL}/controllableMedia/output`,
  GET_CONTROLLABLE_OUTPUT: (event_id) =>
    `${BASE_URL}/controllableMedia/getOutput?eventId=${event_id}`,
};

export let SIGNALING_SERVER_URL = "";
export function updateSignallingUrl(signalingUrl) {
  SIGNALING_SERVER_URL = signalingUrl;
}

export let ICE_SERVERS = [];
export function updateICEServers(iceServers) {
  ICE_SERVERS = iceServers;
}

let CDN_URL =
  process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:10000/devstoreaccount1/public/site/external"
    : "https://cdn.uvenu.com/site/external";
export let CDN_URLS = {
  UVENU_LOADING: `${CDN_URL}/Uvenu_Loading.gif`,
  MOBILE_FRAME: `${CDN_URL}/mobile_frame.png`,
  BRIGHTNESS: `${CDN_URL}/increase_brightness.webm`,
  SHADOW_BACKGROUND: `${CDN_URL}/uvenu_background_shade.png`,
  AVIATORS_EFFECT: `${CDN_URL}/DeepAR/aviators.deepar`,
  FIRE_EFFECT: `${CDN_URL}/DeepAR/fireEffect.deepar`,
  JAGS_FACEPAINT_EFFECT: `${CDN_URL}/DeepAR/JAGS_FACEPAINT_V1.deepar`,
  NFL_HELMET_EFFECT: `${CDN_URL}/DeepAR/nfl-helmet-red.deepar`,
  EVENT_JSON_DATA_LINK: (eventId) =>
    `${CDN_URL}/events/${eventId}/sharedMedia/files.json`,
  FFMPEG_CORE: `${CDN_URL}/ffmpeg/v1/ffmpeg-core.js`,
  FFMPEG_WASM: `${CDN_URL}/ffmpeg/v1/ffmpeg-core.wasm`,
  FFMPEG_CORE_WORKER: `${CDN_URL}/ffmpeg/v1/ffmpeg-core.worker.js`,
  FLASH_ON: `${CDN_URL}/flashlighton.svg`,
  FLASH_OFF: `${CDN_URL}/flashlightoff.svg`,
  LIGHTSHOW_DEFAULT_AD: `${CDN_URL}/lightShowDefaultAd.mp4`,
  MUTE: `${CDN_URL}/mute.svg`,
  UNMUTE: `${CDN_URL}/unmute.svg`,
};

export function updateCDNUrls(cdnUrl = CDN_URL) {
  CDN_URL = cdnUrl;
  CDN_URLS = {
    UVENU_LOADING: `${CDN_URL}/Uvenu_Loading.gif`,
    MOBILE_FRAME: `${CDN_URL}/mobile_frame.png`,
    BRIGHTNESS: `${CDN_URL}/increase_brightness.webm`,
    SHADOW_BACKGROUND: `${CDN_URL}/uvenu_background_shade.png`,
    AVIATORS_EFFECT: `${CDN_URL}/DeepAR/aviators.deepar`,
    FIRE_EFFECT: `${CDN_URL}/DeepAR/fireEffect.deepar`,
    JAGS_FACEPAINT_EFFECT: `${CDN_URL}/DeepAR/JAGS_FACEPAINT_V1.deepar`,
    NFL_HELMET_EFFECT: `${CDN_URL}/DeepAR/nfl-helmet-red.deepar`,
    EVENT_JSON_DATA_LINK: (eventId) =>
      `${CDN_URL.replace(
        "/site/external",
        ""
      )}/events/${eventId}/sharedMedia/files.json`,
    FFMPEG_CORE: `${CDN_URL}/ffmpeg/v1/ffmpeg-core.js`,
    FFMPEG_WASM: `${CDN_URL}/ffmpeg/v1/ffmpeg-core.wasm`,
    FFMPEG_CORE_WORKER: `${CDN_URL}/ffmpeg/v1/ffmpeg-core.worker.js`,
    FLASH_ON: `${CDN_URL}/flashlighton.svg`,
    FLASH_OFF: `${CDN_URL}/flashlightoff.svg`,
    LIGHTSHOW_DEFAULT_AD: `${CDN_URL}/lightShowDefaultAd.mp4`,
  };
}

export let APP_INSIGHTS_CONNECTION_STRING = "InstrumentationKey=df12b0c4-ad0d-40e4-a092-bb4f24230a48;IngestionEndpoint=https://westus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://westus.livediagnostics.monitor.azure.com/";
export function updateAppInsightsConnectionString(connectionString) {
  APP_INSIGHTS_CONNECTION_STRING = connectionString;
}
export const MAX_QUOTE_LENGTH = 150;
export const LIBRARIES = ["places"];
export const ENABLE_WEBRTC_DEBUG_LOGGING = true;
export const WEB_PUBSUB_SOCKETIO_ENDPOINT = "https://dev-w-uvenu-socketio.webpubsub.azure.com";
export const WEB_PUBSUB_CLIENT_PATH = "/clients/socketio/hubs/Hub";
export const REACT_APP_GOOGLE_API_KEY = "AIzaSyCMSDz67I_529-1zB4GD8MdHBBMpXObnCA";
export const SUBMITTED_GAME_IDS_KEY = "gamesPollsStateStore";
export const CAPTURE_SOURCES = {
  SOCIAL_LOGIN: "social_login",
  GAMES_LOGIN: "games_login",
  LIVE_CAM_LOGIN: "live_cam_login",
};
export const WEB_APP_LOGIN_KEY = "web_app_login_inputs";
export const GAME_AD_EMAIL_SUBMITTED_KEY = "game_ad_email_submitted";
export const GET_GAME_RESULT_POLLING_INTERVAL = 30000;
export const FAL_KEY = "d4e85393-4d16-4cbb-b4b1-2720c34d4abd:8c3bf3ab1548d1e8ef4c1540d54e393d";
export const FAL_MODEL = "fal-ai/flux-pulid";
export const FAL_TRANSITION_API = "fal-ai/pixverse/v3.5/transition";
export const NEGATIVE_PROMPT =
  "bad quality, worst quality, text, signature, watermark, extra limbs, nudity";
export const getControllableRoomId = (eventId) => {
  return `${eventId}-contorllable-output`;
};
export const AI_VIDEO_TRANSITION_DEFAULT_PROMPT = "a person transitions into another character"








